/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaAddressListRequest = {
    page?: number;
    size?: number;
    sortDirection?: SomniaAddressListRequest.sortDirection;
};

export namespace SomniaAddressListRequest {

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

